import { resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "service_sidebar__card row items-center justify-center" }
const _hoisted_2 = { class: "service_sidebar__card-body row s-pt-sm" }
const _hoisted_3 = { class: "col-xs-12 row justify-end" }
const _hoisted_4 = { class: "col-xs-12 row service_sidebar__card-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!
  const _component_sidebar_item = _resolveComponent("sidebar-item")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "full-width": "",
    seamless: "",
    position: "top",
    class: "service_sidebar"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "service_sidebar__card-dialog" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createVNode(_component_s_btn, {
                  type: "icon",
                  class: "s-btn--action s-btn--icon__dark-gray",
                  "no-caps": "",
                  icon: "app:close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (group, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: group.id,
                    class: "col-xs-12 col-sm-6 col-md-4 row service__item-wrapper"
                  }, [
                    _createVNode(_component_sidebar_item, {
                      class: "col-xs-12",
                      group: group,
                      "icon-number": index,
                      onClose: _ctx.close
                    }, null, 8, ["group", "icon-number", "onClose"])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}